import { getQuery } from "./UdasWrapper";
import { addErrorLog } from "../Logger/logger";

export const getTenantDataById = async (tenant_id) => {
  try {
    const data = JSON.stringify({
      query: `query Tenantbytenantid($tenantId: String!) {
  tenantbytenantid(tenant_id: $tenantId) {
    tenant_id
    city
    country
    county
    first_name
    last_name
    company_name
    address_line_1
    address_line_2
    state
    zip
    email_address
    business_phone
    mobile
    notes
    website
    status
    config
    logo_url
  }
}`,
      variables: {
        tenantId: tenant_id,
      },
    });
    const response = await getQuery(data, true);
    return response?.tenantbytenantid;
  } catch (error) {
    addErrorLog("error", error);

    if (/Error\s+502:/.test(error.message)) {
      console.log("Retrying to fetch: getTenantDataById");
      return getTenantDataById(tenant_id);
    }

    return null;
  }
};
